<template>
    <UiProductsSectionsHotelProductCarousel :blok="blok" :airport="airport" :products="products" />
</template>

<script lang="ts" setup>
defineProps<{
    blok: any;
    airport: any;
    products: any;
}>();
</script>

<style scoped lang="postcss"></style>
